import MyDealerListPanel from './myDealerListPanel.container';

export default MyDealerListPanel